import styled from 'styled-components';

export const AddMemberForm = styled.form`
display: flex;
flex-direction: column;
gap: 15px;
`;

export const InputWrapper = styled.div`

`;

export const InputLabel = styled.label`
font-size: 14px;
color: #33682c;
`;

export const PopupInput = styled.input`
border: none;
border-bottom: 2px solid #D3D3D3;
height: 30px;
width: 100%;
transition: all 0.2s ease-in-out;
font-size: 18px;
padding-bottom: 5px;

&:focus {
    outline: none;
    border-bottom: 2px solid #33682c;
}
`;

export const UpdateButton = styled.button`
width: 100%;
height: 100%;
padding: 15px;
border-radius: 5px;
border: none;
background: linear-gradient(215deg, rgba(51,104,44,1) 0%, rgba(97,150,87,1) 100%);
color: #fff;
margin-top: 25px;
font-size: 18px;

&:hover {
    transition: all 0.2s ease-in-out;
    transform: scale(1.02);
    background: linear-gradient(45deg, rgba(51,104,44,1) 0%, rgba(97,150,87,1) 100%);
    cursor: pointer;
}

&:disabled {
  color: #fff;
  background: #808080;

  &:hover {
    cursor: not-allowed;
    transform: scale(1);
    background: #808080;
}}
`;

export const Feedbacktext = styled.p`
font-size: 16px;
color: #000;
text-align: center;
`;

export const ErrorText = styled.p`
font-size: 14px;
color: #fff;
text-align: left;
margin-top: 10px;
border-radius: 10px;
padding: 10px;
background-color: #619657;
`;

export const WhitelistSelect = styled.select`
width: 100%;
height: 40px;
margin-top: 5px;
border-radius: 5px;
padding-left: 10px;
`;

export const TextArea = styled.textarea`
width: 100%;
height: 150px;
padding: 6px 10px;
box-sizing: border-box;
border: 2px solid #ccc;
border-radius: 4px;
background-color: #f8f8f8;
font-size: 16px;
resize: none;
`;
